//BRAND
export const name = 'Drope AI';
export const company = 'Drope AI';
export const websiteURL = 'https://courses.dropeai.com';
export const serverURL = 'https://dropai.onrender.com';
export const logo = 'https://courses.dropeai.com/logo512(1).png';
export const razorpayEnabled = true;
export const paypalEnabled = true;
export const stripeEnabled = false;
export const paystackEnabled = false;
export const flutterwaveEnabled = false;

//PRICING :-

//FREE 
export const FreeType = 'Free Plan';
export const FreeCost = 0;
export const FreeTime = '';

//MONTHLY 
export const MonthType = 'Monthly Plan';
export const MonthCost = 4;
export const MonthTime = 'month';

//YEARLY 
export const YearType = 'Yearly Plan';
export const YearCost = 44;
export const YearTime = 'year';

//TESTIMONIAL
export const review = "The AI Course Generator revolutionized my content creation process, providing accurate and relevant topics effortlessly. It's a time-saving powerhouse that enhances the quality and relevance of my courses. A must-have tool for educators seeking efficiency and impactful online learning experiences.";
export const from = "Christopher Hamilton";
export const profession = 'Drope AI';
export const photoURL = 'https://courses.dropeai.com/logo512(1).png';

//PAYPAL
export const paypalPlanIdOne = "P-2LD35802HL373974CM5X4X3Q";
export const paypalPlanIdTwo = "P-2K685412WT958443YM5X4ZDI";

//RAZORPAY
export const razorpayKeyId = "rzp_live_KOBCWLG6v62Zck";
export const razorpayPlanIdOne = "plan_PcTS0iznnp1ffH";
export const razorpayPlanIdTwo = "plan_PcTV5w4MljwdCR";

//STRIPE
export const stripePlanIdOne = "price_1OTo7CSDXmLtVnVeaHIHxqCj";
export const stripePlanIdTwo = "price_1OTo7eSDXmLtVnVeBbn82U5B";

//PAYSTACK
export const paystackPlanIdOne = "PLN_ouqmm8eo6i2k9k8";
export const paystackPlanIdTwo = "PLN_1v1xqb8io9t5lis";
export const amountInZarOne = '170';
export const amountInZarTwo = '1871';

//FLUTTERWAVE
export const flutterwavePlanIdOne = "67960";
export const flutterwavePlanIdTwo = "67961";
export const flutterwavePublicKey = "FLWPUBK_TEST-6ee1faf6460ea587f510a024ac4c2b23-X";

//SOCIAL SIGNIN
export const googleClientId = "150644331076-flt197jvuqg9ohlf6q9rsjk3e3qomjd2.apps.googleusercontent.com";
export const facebookClientId = "8065327730213158";